// 净值接口model
import Model, { valueWithArray } from 'ducker-model';
import isEmpty from '@fund/basic-lib/dist/lib/lang/isEmpty';
import chartTool from '../utils/chart';

// 单位净值
const netValueProperty = {
  date: String,
  value: String,
  type: String,
};

const netValueReplaceName = {
  date: 'FSRQ',
  value: {
    property: 'DWJZ',
    defaultValue: null,
    computed: (value) => (isEmpty(value) ? null : parseFloat(value)),
  },
  type: {
    defaultValue: 'per-net-value',
  },
};

const netValueModel = new Model(netValueProperty, netValueReplaceName);

// 累计净值
const historyValueProperty = {
  date: String,
  value: String,
  type: String,
};

const historyValueReplaceName = {
  date: 'FSRQ',
  value: {
    property: 'LJJZ',
    defaultValue: null,
    computed: (value) => (isEmpty(value) ? null : parseFloat(value)),
  },
  type: {
    defaultValue: 'history-net-value',
  },
};

const historyValueModel = new Model(historyValueProperty, historyValueReplaceName);

// 净值涨幅
const valueRiseProperty = {
  date: String,
  value: String,
  type: String,
};

const valueRiseReplaceName = {
  date: 'FSRQ',
  value: {
    property: 'JZZZL',
    defaultValue: null,
    computed: (value) => (isEmpty(value) ? null : parseFloat(value)),
  },
  type: {
    defaultValue: 'net-value-rise',
  },
};

const valueRiseModel = new Model(valueRiseProperty, valueRiseReplaceName);

// 货币基一年定存
const valueRateProperty = {
  date: String,
  value: String,
  type: String,
};

const valueRateReplaceName = {
  date: 'FSRQ',
  value: {
    property: 'RATE',
    defaultValue: null,
    computed: (value) => (isEmpty(value) ? null : parseFloat(value)),
  },
  type: {
    defaultValue: 'net-value-rate',
  },
};

const valueRateModel = new Model(valueRateProperty, valueRateReplaceName);

// Model
const property = {
  netValueList: valueWithArray(Object),
  historyValueList: valueWithArray(Object),
  valueRiseList: valueWithArray(Object),
  valueRateList: valueWithArray(Object),
  extraInfo: Object,
};

const replacedKeyFromPropertyName = {
  netValueList: {
    property: 'data',
    computed: (data) => netValueModel.objectArrayWithKeyValuesArray(data),
  },
  historyValueList: {
    property: 'data',
    computed: (data) => historyValueModel.objectArrayWithKeyValuesArray(data),
  },
  valueRiseList: {
    property: 'data',
    computed: (data) => valueRiseModel.objectArrayWithKeyValuesArray(data),
  },
  valueRateList: {
    property: 'data',
    computed: (data) => valueRateModel.objectArrayWithKeyValuesArray(data),
  },
  extraInfo: {
    property: ['expansion[0]', 'expansion'],
    // eslint-disable-next-line no-unused-vars
    computed: ([emptyItem, expansion]) => { // emptyItem 处理model类型问题
      const changeInfo = expansion || [];
      return {
        changePoints: chartTool.handleChangeInfo(changeInfo),
      };
    },
  },
};

export default new Model(property, replacedKeyFromPropertyName);
